"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require("../styles/Container.css");
var _dist = require("package_ui_ihm/dist");
var _jsxRuntime = require("react/jsx-runtime");
/**
* Nom : Container.js
* Description : Ce fichier contient la définition du composant Container 
*               Ce composant est une section de la page pour recevoir son contenu en mettant des marges pour une meilleure
*               présentation
* Date de création : 23 septembre 2024
*/

/* CSS et assets */

/* Bibliothèques et composants */
// None

/* Hook */

/**
* Container : ce composant affiche le contenu qui lui est fourni en respectant un style imposant des marges sur la page
*
* Type : composant 
*
* Parametres : 
*  - children -- contenu à afficher sur la page
*/function Container(_ref) {
  var children = _ref.children;
  // Define useScreenWidth hooks
  var screenWidth = (0, _dist.useScreenWidth)();

  // Render component
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
    className: screenWidth > 650 ? 'container' : 'container-ss',
    children: children
  });
}
var _default = exports["default"] = Container;